"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeMenuCell = exports.TYPE_MENU_CELL_WIDTH = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const slim_1 = require("@blockprotocol/type-system/slim");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const design_system_1 = require("@hashintel/design-system");
const material_1 = require("@mui/material");
const hooks_1 = require("material-ui-popup-state/hooks");
const react_1 = require("react");
const read_only_context_1 = require("../../shared/read-only-context");
exports.TYPE_MENU_CELL_WIDTH = 70;
const TypeMenuCell = ({ typeId, variant, editable = true, editButtonProps, onRemove, editButtonDisabled, }) => {
    const version = (0, slim_1.extractVersion)(typeId);
    const ontology = (0, design_system_1.parseUrlForOntologyChip)(typeId);
    const popupId = (0, react_1.useId)();
    const popupState = (0, hooks_1.usePopupState)({
        variant: "popover",
        popupId: `property-menu-${popupId}`,
    });
    const isReadonly = (0, read_only_context_1.useIsReadonly)();
    const canEdit = editable && !isReadonly;
    const EditButton = (0, react_1.useCallback)(() => ((0, jsx_runtime_1.jsx)(design_system_1.MenuItem, { ...editButtonProps, disabled: !!editButtonDisabled, onClick: (evt) => {
            popupState.close();
            editButtonProps?.onClick?.(evt);
        }, onTouchStart: (evt) => {
            popupState.close();
            editButtonProps?.onTouchStart?.(evt);
        }, children: (0, jsx_runtime_1.jsx)(material_1.ListItemText, { primary: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Edit ", variant] }) }) })), [editButtonDisabled, popupState, editButtonProps, variant]);
    return ((0, jsx_runtime_1.jsxs)(material_1.TableCell, { width: 70, sx: {
            [`.${material_1.iconButtonClasses.root}`]: {
                opacity: 0,
                [`.${material_1.tableRowClasses.root}:hover > &`]: {
                    opacity: 1,
                },
            },
        }, children: [(0, jsx_runtime_1.jsx)(design_system_1.IconButton, { ...(0, hooks_1.bindTrigger)(popupState), children: (0, jsx_runtime_1.jsx)(design_system_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faEllipsis, sx: (theme) => ({
                        fontSize: 14,
                        color: theme.palette.gray[50],
                    }) }) }), (0, jsx_runtime_1.jsxs)(material_1.Menu, { ...(0, hooks_1.bindMenu)(popupState), 
                // We need the table's hover state to stay correct when this opens
                disablePortal: true, anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "right",
                }, transformOrigin: {
                    vertical: "top",
                    horizontal: "right",
                }, sx: (theme) => ({
                    [`.${material_1.listItemClasses.root}, .${material_1.menuItemClasses.root}`]: {
                        px: 1.5,
                        py: 1,
                    },
                    ".MuiTypography-smallCaps": {
                        color: theme.palette.gray[50],
                    },
                    ".MuiTypography-microText": {
                        color: theme.palette.gray[60],
                    },
                    [`.${material_1.listItemClasses.root}`]: {
                        userSelect: "none",
                        cursor: "default",
                    },
                    [`.${material_1.listItemTextClasses.root}`]: {
                        m: 0,
                    },
                }), children: [canEdit
                        ? [
                            (0, jsx_runtime_1.jsx)(material_1.Typography, { component: material_1.ListItem, variant: "smallCaps", children: "Actions" }, "actions"),
                            editButtonDisabled ? ((0, jsx_runtime_1.jsx)(material_1.Tooltip, { title: editButtonDisabled, children: (0, jsx_runtime_1.jsx)(material_1.Box, { children: (0, jsx_runtime_1.jsx)(EditButton, {}) }) }, "edit")) : ((0, jsx_runtime_1.jsx)(EditButton, {}, "edit")),
                            (0, jsx_runtime_1.jsx)(design_system_1.MenuItem, { onClick: () => {
                                    popupState.close();
                                    onRemove?.();
                                }, children: (0, jsx_runtime_1.jsx)(material_1.ListItemText, { primary: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Remove ", variant] }) }) }, "remove"),
                            (0, jsx_runtime_1.jsx)(material_1.Divider, {}, "divider"),
                        ]
                        : null, (0, jsx_runtime_1.jsx)(material_1.Typography, { component: material_1.ListItem, variant: "smallCaps", children: "Source" }), (0, jsx_runtime_1.jsx)(material_1.ListItem, { sx: { pt: "0 !important" }, children: (0, jsx_runtime_1.jsx)(material_1.Tooltip, { title: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [ontology.domain, "/", ontology.path] }), placement: "bottom", children: (0, jsx_runtime_1.jsx)(design_system_1.OntologyChip, { ...ontology, path: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: ontology.path.split("/").map((part, idx, parts) => {
                                        const last = idx === parts.length - 1;
                                        return (
                                        // eslint-disable-next-line react/no-array-index-key
                                        (0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { component: "span", maxWidth: last ? "5ch" : "6ch", children: part }), last ? null : (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "/" })] }, idx));
                                    }) }) }) }) }), (0, jsx_runtime_1.jsx)(material_1.Divider, {}), (0, jsx_runtime_1.jsx)(material_1.ListItem, { children: (0, jsx_runtime_1.jsx)(material_1.ListItemText, { primary: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Version ", version] }), primaryTypographyProps: { variant: "microText", fontWeight: 500 } }) })] })] }));
};
exports.TypeMenuCell = TypeMenuCell;
